import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-polizas-editar',
  templateUrl: './polizas-editar.component.html',
  styleUrls: ['./polizas-editar.component.scss']
})
export class PolizasEditarComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/Contabilidad/polizas/polizas-editar/polizas-editar.component.ts